import React, { createContext, useContext, useState, useEffect } from 'react';
import { login as apiLogin } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    const u = localStorage.getItem('chatmj_usuario');
    if (u) setUsuario(JSON.parse(u));
    setCarregando(false);
  }, []);

  async function login(email, senha) {
    const { data } = await apiLogin(email, senha);
    localStorage.setItem('chatmj_token', data.token);
    localStorage.setItem('chatmj_usuario', JSON.stringify(data.usuario));
    setUsuario(data.usuario);
    return data.usuario;
  }

  function logout() {
    localStorage.removeItem('chatmj_token');
    localStorage.removeItem('chatmj_usuario');
    setUsuario(null);
  }

  return (
    <AuthContext.Provider value={{ usuario, login, logout, carregando }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
